<template>
    <div class="overflow-container"
        :class="{'overflow-container-active': hasOverflow}"
    >
        <slot></slot>
        <div v-if="hasOverflow && count" 
            class="overflow-container-count"
            @click="$emit('click')"
            :title="title"
        >
            <span>{{count}} items</span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'OverflowContainer',
    props: {
        count: {
            type: Number,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
    },
    data: function() {
        return {
            hasOverflow: false,
        }
    },
    mounted() {
        this.hasOverflow = (this.$el.offsetHeight < this.$el.scrollHeight);
    },
}
</script>
<style>
.overflow-container {
    height: 100%;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
}

.overflow-container-count {
    bottom: 20px;
    background: #fff;
    position: absolute;
    text-align: center;
    width: 100%;
    cursor: pointer;
}
.overflow-container-count span {
    border-top: 1px solid;
    font-size: 10px;
}
</style>